// extracted by mini-css-extract-plugin
export default {"pageHero":"l6BocgWpRX","pageHeroImage":"FFKB3n3RW9","pageHeroBackground":"GvBhZ9xe2P","pageHeroContent":"s1txlzbGKa","withClientHeader":"cBJfynysFJ"};